<template>
  <main>
    <div class="policy__HelpPageContainer-sc-1we1f6w-2 jtUkAK"><h3 class="policy__Heading-sc-1we1f6w-0 iMRVsl">CHÍNH
      SÁCH BẢO MẬT</h3>
      <div class="policy__TextItem-sc-1we1f6w-6 kAZYHr">1. Mục đích và phạm vi thu thập</div>
      <br>
      <p>Việc thu thập dữ liệu chủ yếu trên EPIS VN bao gồm: email, điện thoại, tên đăng nhập, mật khẩu đăng nhập, địa
        chỉ Khách hàng. Đây là các thông tin mà EPIS VN cần Khách hàng cung cấp bắt buộc khi đăng ký sử dụng dịch vụ và
        EPIS VN sử dụng nhằm liên hệ xác nhận khi Khách hàng đăng ký sử dụng dịch vụ trên EPIS VN, đảm bảo quyền lợi cho
        Khách hàng.</p><br>
      <p>Các Khách hàng sẽ tự chịu trách nhiệm về bảo mật và lưu giữ mọi hoạt động sử dụng dịch vụ dưới tên đăng ký, mật
        khẩu và hộp thư điện tử của mình. Ngoài ra, Khách hàng có trách nhiệm thông báo kịp thời cho EPIS VN về những
        hành vi sử dụng trái phép, lạm dụng, vi phạm bảo mật, lưu giữ tên đăng ký và mật khẩu của bên thứ ba để có biện
        pháp giải quyết phù hợp.</p><br>
      <div class="policy__TextItem-sc-1we1f6w-6 kAZYHr">2. Phạm vi sử dụng thông tin</div>
      <br>
      <p>EPIS VN sử dụng thông tin Khách hàng cung cấp để:</p>
      <ul class="policy__UlStyle-sc-1we1f6w-4 kdycwj">
        <li class="policy__LiStyle-sc-1we1f6w-5 gDuWge">Cung cấp các dịch vụ đến Khách hàng.</li>
        <li class="policy__LiStyle-sc-1we1f6w-5 gDuWge">Gửi các thông báo về các hoạt động trao đổi thông tin giữa Khách
          hàng và người bán.
        </li>
        <li class="policy__LiStyle-sc-1we1f6w-5 gDuWge">Ngăn ngừa các hoạt động phá hủy tài khoản người dùng của Khách
          hàng hoặc các hoạt động giả mạo Khách hàng.
        </li>
        <li class="policy__LiStyle-sc-1we1f6w-5 gDuWge">Liên lạc và giải quyết với khách hàng trong những trường hợp đặc
          biệt.
        </li>
        <li class="policy__LiStyle-sc-1we1f6w-5 gDuWge">Không sử dụng thông tin cá nhân của Khách hàng ngoài mục đích
          xác nhận và liên hệ có liên quan đến giao dịch tại EPIS VN.
        </li>
        <li class="policy__LiStyle-sc-1we1f6w-5 gDuWge">EPIS VN có trách nhiệm hợp tác cung cấp thông tin cá nhân Khách
          hàng khi có yêu cầu từ cơ quan nhà nước có thẩm quyền.
        </li>
      </ul>
      <br></div>
  </main>
</template>

<script>
export default {
  name: "Policy",
  data() {
    return {}
  },
  components: {},
  mounted() {

  },
  methods: {},
  created() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Policy.vue